module.exports = __webpack_public_path__ + "1bb12f4f/img/comments-icon.334fbbd6.svg";